// extracted by mini-css-extract-plugin
export default {"wrapper":"message_wrapper__F5T98","success":"message_success__wOX0s","error":"message_error__QQgRM"};